import { AcceptCryptoLegalDocData, AcceptCryptoLegalDocResponse } from "./types"
import CommonApiError from "../../../errors/CommonApiError"
import parseHttpApiError from "../../../utils/parseHttpApiError"
import { AcceptCryptoLegalDocDocument } from "../../__generated__/graphql"
import apolloClient, { normalizeApolloError } from "../../apolloClient"
import { IGQLApiError } from "../../types"

export const acceptCryptoLegalDoc = async (
    data: AcceptCryptoLegalDocData
): Promise<AcceptCryptoLegalDocResponse> => {
    const variables = {
        input: {
            companyId: data.companyId,
            cryptoProviderTermsId: data.cryptoProviderTermsId,
            source: data.source,
        },
    }

    try {
        const result = await apolloClient.mutate<
            AcceptCryptoLegalDocResponse["data"],
            typeof variables
        >({
            context: {
                headers: {
                    Authorization: `Bearer ${data.accessToken}`,
                },
            },
            fetchPolicy: "no-cache",
            mutation: AcceptCryptoLegalDocDocument,
            variables,
        })
        return { data: result.data! }
    } catch (err: unknown) {
        const error = normalizeApolloError(err)
        if (error instanceof CommonApiError) {
            throw parseHttpApiError(error.body as IGQLApiError[])
        }
        throw error
    }
}
